<template>
    <div class="construction">
      <HeaderStyles2
        :image="headerBg"
        :title="$t('hospitality-title')"
        :content="$t('hospitality-detail')"
      />

      <main class="main-content">
        <b-container fluid="xl">
          <section class="content-section">
            <h2 class="section-title" v-html="$t('hospitality-section-1-title')"></h2>
            <b-row class="section-content">
              <b-col cols="12" xl="6" md="6" sm="12"><b-img fluid src="../assets/imgs/hospitality-section-1-image.png"></b-img></b-col>
              <b-col cols="12" xl="6" md="6" sm="12" class="section-detail-1" v-html="$t('hospitality-section-1-detail')"></b-col>
            </b-row>
          </section>

          <section class="content-section">
            <h2 class="section-title" v-html="$t('hospitality-section-2-title')"></h2>
            <p class="section-content" v-html="$t('hospitality-section-2-detail')"></p>
          </section>

          <section class="content-section">
            <b-row>
              <b-col cols="12" xl="7" md="7" sm="12">
                <ul class="section-ul">
                  <li>
                    <b-img src="../assets/imgs/icon-handshake.png"></b-img>
                    <span>{{$t('hospitality-section-2-list-item-1')}}</span>
                  </li>
                  <li>
                    <b-img src="../assets/imgs/icon-db-arrow.png"></b-img>
                    <span>{{$t('hospitality-section-2-list-item-2')}}</span>
                  </li>
                  <li>
                    <b-img src="../assets/imgs/icon-laugh.png"></b-img>
                    <span>{{$t('hospitality-section-2-list-item-3')}}</span>
                  </li>
                </ul>
              </b-col>
              <b-col cols="12" xl="5" md="5" sm="12">
                <b-img fluid src="../assets/imgs/hospitality-list-image.png"></b-img>
              </b-col>
            </b-row>
          </section>

          <section class="content-section">
            <h2 class="section-title" v-html="$t('hospitality-section-3-title')"></h2>
            <b-row class="text-img-style">
              <b-col cols="12" xl="4" md="4" sm="12">
                <b-img src="../assets/imgs/icon-wayfindeing.png" alt="" />
                <h4 v-html="$t('hospitality-section-3-item-1-title')"></h4>
                <p v-html="$t('hospitality-section-3-item-1-detail')"></p>
              </b-col>
              <b-col cols="12" xl="4" md="4" sm="12">
                <b-img src="../assets/imgs/icon-accessibility.png" alt="" />
                <h4 v-html="$t('hospitality-section-3-item-2-title')"></h4>
                <p v-html="$t('hospitality-section-3-item-2-detail')"></p>
              </b-col>
              <b-col cols="12" xl="4" md="4" sm="12">
                <b-img src="../assets/imgs/icon-interactive-kiosk-maps.png" alt="" />
                <h4 v-html="$t('hospitality-section-3-item-3-title')"></h4>
                <p v-html="$t('hospitality-section-3-item-3-detail')"></p>
              </b-col>
              <b-col cols="12" xl="4" md="4" sm="12">
                <b-img src="../assets/imgs/icon-personal-map.png" alt="" />
                <h4 v-html="$t('hospitality-section-3-item-4-title')"></h4>
                <p v-html="$t('hospitality-section-3-item-4-detail')"></p>
              </b-col>
              <b-col cols="12" xl="4" md="4" sm="12">
                <b-img src="../assets/imgs/icon-multiple-devices.png" alt="" />
                <h4 v-html="$t('hospitality-section-3-item-5-title')"></h4>
                <p v-html="$t('hospitality-section-3-item-5-detail')"></p>
              </b-col>
              <b-col cols="12" xl="4" md="4" sm="12">
                <b-img src="../assets/imgs/icon-indoor-navigation.png" alt="" />
                <h4 v-html="$t('hospitality-section-3-item-6-title')"></h4>
                <p v-html="$t('hospitality-section-3-item-6-detail')"></p>
              </b-col>
            </b-row>
          </section>
        </b-container>
      </main>
    </div>
</template>

<script>
import HeaderStyles2 from '../components/HeaderStyles2.vue'

export default {
  name: 'Hospitality',
  components: {
    HeaderStyles2
  },
  data () {
    return {
      headerBg: require('../assets/imgs/header-bg-img-hospitality.png')
    }
  }
}
</script>

<style scoped lang="scss" src="./solution-item-styles.scss"></style>
